import * as React from "react";
import { ThemeProvider, createTheme, Typography, Box, Grid, Button, Modal } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import pic1 from "./photography/bern2025/bern2025_1.jpg";
import pic2 from "./photography/bern2025/bern2025_2.jpg";
import pic3 from "./photography/bern2025/bern2025_3.jpg";
import pic4 from "./photography/bern2025/bern2025_4.jpg";
import pic5 from "./photography/bern2025/bern2025_5.jpg";
import pic6 from "./photography/bern2025/bern2025_6.jpg";
import pic7 from "./photography/bern2025/bern2025_7.jpg";
import pic8 from "./photography/bern2025/bern2025_8.jpg";
import pic9 from "./photography/bern2025/bern2025_9.jpg";

import Footer from "../Footer";

export default function Ukraine2022() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const tablet = useMediaQuery("(min-width:768px) and (max-width:1000px)");

  const images = [pic1, pic5, pic7, pic2, pic8, pic3, pic4, pic6, pic9];

  const [open, setOpen] = React.useState(false);
  const [modalSrc, setModalSrc] = React.useState(null);

  const handleOpen = (src) => {
    setModalSrc(src);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh"
      >

        <Box sx={{ mb: "5vh" }}>
          <Typography
            variant="h1"
            component={require("react-router-dom").Link}
            to="/ph"
            sx={{
              textAlign: "center",
              color: "inherit",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            // bern 2025
          </Typography>
        </Box>

        {/* Intro */}
        <Box sx={{ width: "60vw", maxWidth: 1200, mb: "5vh", textAlign: "center" }}>
          <Typography variant="body1">
            The moment I set foot in Bern with the goal of documenting the protest against the genocide, a group of police in riot gear stopped and searched me – right at the train station.

            They “preventively” banned me from entering the city for 48 hours.

            The reason? A camera, a couple of face masks, and a marker in my bag.
          </Typography>
        </Box>

        {/* Grid */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ width: "80vw", maxWidth: 1200 }}
        >
          {images.map((src, i) => {
            if (tablet) {
              return (
                <Grid key={i} item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                  <img src={src} alt={`Ukraine 2022 ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else if (sm) {
              return (
                <Grid key={i} item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                  <img src={src} alt={`Ukraine 2022 ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else {
              return (
                <Grid key={i} item xs={3} sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={() => handleOpen(src)}
                    sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in" }}
                  >
                    <img src={src} alt={`Ukraine 2022 ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                  </Button>
                </Grid>
              );
            }
          })}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "80vh",
            display: "flex",
          }}
        >
          {modalSrc && (
            <img
              src={modalSrc}
              alt="Preview"
              style={{ maxWidth: "90vw", maxHeight: "80vh", width: "auto", height: "auto" }}
            />
          )}
        </Box>
      </Modal>

      <Footer fixed />
    </ThemeProvider>
  );
}
